import request from './index.js'

// 系统相关接口
export const systemApi = {
  // 获取企业信息列表
  getCompanyList: () => request({
    method: 'GET',
    url: '/system/company/list'
  }),
  
  // 获取软件产品列表
  getProductList: () => request({
    method: 'GET',
    url: '/system/product/list'
  }),
  
  // 获取技术优势列表
  getAdvantageList: () => request({
    method: 'GET',
    url: '/system/advantage/list'
  }),
  
  // 获取客户案例列表
  getCustomerList: () => request({
    method: 'GET',
    url: '/system/customer/list'
  }),
  
  // 提交联系表单
  submitContactForm: (data) => request({
    method: 'POST',
    url: '/system/contact/submit',
    data
  })
}

// 新闻相关接口
export const newsApi = {
  // 获取新闻列表
  getNewsList: (params) => request({
    method: 'GET',
    url: '/news/list',
    params
  }),
  
  // 获取新闻详情
  getNewsDetail: (id) => request({
    method: 'GET',
    url: `/news/detail/${id}`
  })
}

// 服务相关接口
export const serviceApi = {
  // 获取服务列表
  getServiceList: (params) => request({
    method: 'GET',
    url: '/service/list',
    params
  }),
  
  // 获取服务详情
  getServiceDetail: (id) => request({
    method: 'GET',
    url: `/service/detail/${id}`
  })
}

// 软件产品相关接口
export const softwareApi = {
  // 获取软件产品详情
  getSoftwareDetail: (id) => request({
    method: 'GET',
    url: `/software/detail/${id}`
  })
}

// 导出所有API模块
export default {
  system: systemApi,
  news: newsApi,
  service: serviceApi,
  software: softwareApi
}


// WEBPACK FOOTER //
// ./src/api/api.js